import { intlayerMessages } from './adapters/intlayer-messages'
import type { MessageKey, MessageParams } from './domain/message'

const resolveMessage = (key: MessageKey, params?: MessageParams) => intlayerMessages.resolve(key, params)

export { resolveMessage }
